<template>
    <div class="auth-wrapper auth-v2 bg-white">
        <b-row class="auth-inner m-0">

            <div class="w-100 d-flex flex-column justify-content-between">
                <div class="px-1  bg-white flex-fill">
                    <div class="d-flex flex-column h-100 pt-3 pb-1">

                        <div class="flex-fill">
                            <div style="{ height: 100%;margin: 0em;overflow-y: auto;}">
                            <!-- Display the data -->
                                <b-card v-if="!modalShow" header-border-variant="Primary" width="80%"
                                    class="shadow text-center" no-body v-for="(data) in initialData"
                                    style="max-width: 540px;">
                                    <b-row no-gutters>
                                        <b-col md="6">
                                            <b-card-body>
                                                <span
                                                    style="font-weight: 600;font-size: 24px;line-height: 29px;">Usuario</span>
                                                <div class=" d-flex justify-content-end  border-bottom">

                                                    <feather-icon @click="modalShow = !modalShow" icon="Edit2Icon"
                                                        size="20" />
                                                    <feather-icon class="" @click="modalTrashShow = !modalTrashShow"
                                                        icon="TrashIcon" size="20" />
                                                </div>
                                                <blockquote class="blockquote mb-0"></blockquote>
                                                <span> <img class="mt-3 mb-2 rounded-circle"
                                                        src="@/assets/images/ganImage/UserImage.png" alt="" /></span>
                                                <b-card-text class="mb-3">
                                                    <div class="d-flex justify-content-between">
                                                        <div> Nombre: </div>
                                                        <div> {{ data.name }}</div>
                                                    </div>
                                                    <div class="d-flex justify-content-between">
                                                        <div> Permisos: </div>
                                                        <div> {{ data.author }}</div>
                                                    </div>
                                                    <div class="d-flex justify-content-between">
                                                        <div> Edad: </div>
                                                        <div> {{ data.age }}</div>
                                                    </div>
                                                </b-card-text>
                                            </b-card-body>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </div>
                            <div class="preTitle">
                            <!-- Edit Modal -->

                                <b-modal centered v-model="modalShow" hide-footer hide-header>

                                    <div class="d-flex align-items-center justify-content-center subTitle pt-2 ml-5">Usuarios
                                  
                                    <div class="d-flex justify-content-end  ml-5">
                                        <feather-icon @click="modalShow = !modalShow" icon="XIcon"
                                            size="20" />
                                    </div></div>
                                    <validation-observer ref="FarmView" #default="{ invalid }">
                                        <div class="d-flex flex-column align-items-center justify-content-center">
                                            <img class="mt-2 mb-2 rounded-circle"
                                                        src="@/assets/images/ganImage/UserImage.png" alt="" />
                                            <b-form class="mt-3">
                                                <b-form-group>
                                                    <div class="d-flex justify-content-center align-items-center mb-2">

                                                        <div class="w-70">
                                                            <validation-provider #default="{ errors }" name="username"
                                                                vid="username" rules="required">
                                                                <b-form-input id="username" v-model="ha" name="username"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="Nombre" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-center align-items-center mb-2">

                                                        <div class="w-70">
                                                            <validation-provider #default="{ errors }" name="age"
                                                                vid="age" rules="required">
                                                                <b-form-input id="age" v-model="apartos"
                                                                    name="age"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="Edad" />
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>
                                                <b-form-group>
                                                    <div class="d-flex justify-content-center align-items-center mb-5">

                                                        <div class="w-100">
                                                            <validation-provider #default="{ errors }" name="author"
                                                                vid="author" rules="required">
                                                                <b-input-group >
                                                                <b-form-input id="author" v-model="apartos"
                                                                    name="author"
                                                                    :state="errors.length > 0 ? false : null"
                                                                    placeholder="Permisos" />
                                                                <b-input-group-append>
                                                                    <b-button @click="addTag()" class="bg-primary">Browse</b-button>
                                                                </b-input-group-append></b-input-group>
                                                                <small class="text-danger">{{ errors[0] }}</small>
                                                            </validation-provider>
                                                        </div>
                                                    </div>
                                                </b-form-group>


                                            </b-form>
                                        </div>
                                    </validation-observer>


                                </b-modal>
                                <!-- Delete Modal -->
                                <b-modal class="modal-lg" centered v-model="modalTrashShow" hide-footer hide-header>
                                    <div class="d-flex  align-items-end justify-content-end">
                                        <feather-icon @click="modalTrashShow = !modalTrashShow" icon="XIcon"
                                            size="20" />
                                    </div>
                                    <div class="d-flex flex-column align-items-center justify-content-center">
                                        <span class="deleteModal mt-2"> ¿Desea eliminar? </span>
                                        <b-button class="deleteButton mt-2 mb-2">Eliminar</b-button>
                                    </div>
                                </b-modal>
                            </div>

                        </div>
                        <div class="d-flex justify-content-end position-fixed" style="right:5%;top:80%">
                            <span class="dataLog  pt-2 mr-1 mt-1 ">Incluir Usuario</span>
                            <b-button class="bg-primary px-0 pt-0 pb-0 mt-2" style="border-radius:50%">
                                <b-link :to="{ name: 'advance-uploaduser' }" style="color:#D7B92C">
                                    <feather-icon icon="PlusIcon" size="45" />
                                </b-link>
                            </b-button>
                        </div>
                    </div>
                </div>
                <ControlMenu />
            </div>
        </b-row>

    </div>
</template>

<script>
import {
    BRow, BCol, BLink, BCardBody, BCard, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText,
} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
export default {
    components: {
        BRow,
        BImg,
        BCol,
        BLink,
        BButton,
        BForm,
        BCardText,
        BCardTitle,
        BFormCheckbox,
        BFormGroup,
        BFormInput,
        BInputGroup,
        ControlMenu,
        BCardBody,
        BCard,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            status: '',
            initialData: [{ name: "John Doe", author: " Subir Datos", age: 34 }, { name: "John Smith", author: " Subir Datos", age: 34 }],
            modalShow: false,
            modalTrashShow: false,
            username: '',
            distrito: '',
            ha: '',
            cantón: '',
            provincia: '',
            sistema: '',
            apartos: '',

        }
    },

}
</script>

<style lang="scss">

.modal-lg {
    max-width: 70% !important;
}
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.subTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.preTitle {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    color: #5E5873;
}

.dataLog {
    font-weight: 500;
    font-size: medium;
    color: #5E8F23;
}

.deleteModal {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
}

.deleteButton {
    border-color: #EA5455 !important;
    padding: 10px 22px;
    box-shadow: inset 0px -3px 0px rgba(255, 0, 0, 0.2) !important;
    border-radius: 49px;
    width: 107px;
    height: 37px;
    background-color: #EA5455 !important;
    mix-blend-mode: normal;
    box-shadow: inset 0px -3px 0px rgba(0, 0, 0, 0.2);

}

#__BVID__54___BV_modal_content_ {
    border-radius: 43px;
}

#__BVID__40___BV_modal_content_ {
    border-radius: 43px;
}

#__BVID__55___BV_modal_content_ {
    border-radius: 25px;
}

#__BVID__41___BV_modal_content_ {
    border-radius: 25px;
}

.modal-content {
    border-radius: 30px;
}

@import '@core/scss/vue/pages/page-auth.scss';
</style>
